import React, { ReactElement, useEffect } from 'react'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import CircularProgress from '@material-ui/core/CircularProgress'
import GetAppIcon from '@material-ui/icons/GetApp'
import { BuildingFilter, FloorFilter, AreaFilter } from 'components/workspace-filter'
import DateRange from 'components/date-range/'
import { Dayjs } from 'dayjs'
import { FormControlLabel, Switch, Typography } from '@material-ui/core'
import { TemperatureToggle } from 'components/temperature-switch/TemperatureToggle'
import { useSelector } from 'react-redux'

interface FilterProps {
  building: null | number
  setBuilding: any
  floor: number[] | number
  setFloor: any
  area: number[] | number
  setArea: any
  initialFrom: Dayjs | undefined | null
  initialTo: Dayjs | undefined | null
  setDateRange: any
  downloadActive: boolean
  downloading: boolean
  onDownload?: (() => void) | undefined | null
  ActionComponent?: ReactElement<any> | undefined | null
  singleSelect?: boolean
  onlyRoom?: boolean
  onlyDesk?: boolean
  workhours?: boolean
  setWorkhours?: any
  currentPage?: string  // Add currentPage prop to specify page context
  hiddenTemperaturePages?: string[]  // Add prop to specify pages where temperature toggle should be hidden
  hideArea?: boolean // Add prop to conditionally hide Area filter
}

const Filters = (
  {
    ActionComponent, building, floor, area, setBuilding, setFloor, setArea, setDateRange, initialFrom,
    initialTo, downloading, onDownload, downloadActive, singleSelect, onlyRoom, onlyDesk, workhours, setWorkhours,
    currentPage,
    hiddenTemperaturePages = ['Health', 'Comfort'],  // Default to empty array if not provided
    hideArea = false
  }: FilterProps) => {
  const floorVal = singleSelect && Array.isArray(floor) ? 0 : floor
  const areaVal = singleSelect && Array.isArray(area) ? 0 : area

  const companyType = useSelector((state: any) => {
    const type = state._user.impersonate?.companyType ?? state.auth.payload?.companyType;
    return type;
  });
  const setBuildingL = (val) => {
    floor && setFloor(undefined)
    area && setArea(undefined)
    setBuilding(val)
  }

  const setFloorL = (val) => {
    area && setArea(null)
    setFloor(val)
  }

  return (
    <Box width="100%" mt={2}>
      <Paper>
        <Box p={2} display="flex" alignItems="center">
          <Box display="flex" flexGrow={1}>
            <Box mr={1}>
              <BuildingFilter building={building} setBuilding={(v) => setBuildingL(v)} DropdownProps={{ multiple: false }} companyType={companyType} />
            </Box>
            <Box mr={1}>
              <FloorFilter
                building={building}
                floor={floorVal}
                setFloor={(v) => setFloorL(v)}
                DropdownProps={{ multiple: !singleSelect }}
                companyType={companyType}
              />
            </Box>
            {!hideArea && (
              <Box>
                <AreaFilter
                  building={building}
                  floor={floorVal}
                  area={areaVal}
                  setArea={setArea}
                  DropdownProps={{ multiple: !singleSelect }}
                  onlyRoom={onlyRoom}
                  onlyDesk={onlyDesk}
                />
              </Box>
            )}
            <Box ml={1}>
              <TemperatureToggle
                currentPage={currentPage}
                hiddenOnPages={hiddenTemperaturePages}
              />
            </Box>
          </Box>
          <Box display="flex" alignItems="center">
            {setWorkhours &&
              <>
                <Box mb={1} mt={1} mr={1}>
                  <Typography variant="subtitle2" color="textSecondary">Only include working hours</Typography>
                </Box>
                <Box flexGrow={1}>
                  <FormControlLabel
                    control={<Switch checked={workhours} onChange={() => setWorkhours(!workhours)} name="workhours" />}
                    label="" />
                </Box>
              </>
            }
            {setDateRange &&
              <DateRange
                onDateRange={(from, to) => setDateRange([from, to])}
                initialFrom={initialFrom}
                initialTo={initialTo}
                variant="outlined"
              />
            }
            {ActionComponent &&
              <Box ml={2}>{ActionComponent}</Box>}
            <Box ml={2}>
              {onDownload &&
                <IconButton disabled={!downloadActive || downloading} onClick={onDownload}>
                  {downloading ? <CircularProgress size={24} color="inherit" /> : <GetAppIcon />}
                </IconButton>
              }
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}

export default Filters